import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import reqwest from 'reqwest';
import swal from '@sweetalert/with-react';
import {
  faSave,
  faTrashAlt,
  faLockOpen,
} from '@fortawesome/pro-regular-svg-icons';
import settings from '../../../../../../../settings';
import DataContainer from '../../../../../../logic/dataContainer';
import Loader from '../../../../../../components/Loader';
import Button from '../../../../../../components/Button';
import HeaderbarButton from '../../../../../../components/HeaderbarButton';
import UserContext from '../../../../../../hooks/UserContext';
import ClinicForm, { REQUIRED } from '../../../ClinicForm';
import {
  DELETE_ERROR_TEXT,
  SAVE_ERROR_TEXT,
  canEditClinics,
  reportClinicRequestError,
} from '../../../clinicAccess';

class SupplynetworkClinicsDetail extends Component {
  constructor(props) {
    super(props);

    this.parentRoute = this.props.match.url.replace(
      new RegExp(`/${props.match.params.userId}$`),
      '',
    );

    this.state = {
      loading: true,
      positions: [],
    };

    const dataPromise = reqwest({
      method: 'get',
      url: settings.supplynetwork.clinics.get,
      data: {
        Token: localStorage.getItem('token'),
        Guid: this.props.UserGuid,
      },
    }).then((res) => {
      this.dataContainer = new DataContainer(res);
    });

    Promise.all([dataPromise]).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  static contextType = UserContext;

  // CanEdit ist false bei Recht "Auswertung" (Nur-Lese-Ansicht).
  canEdit() {
    return (
      canEditClinics(this.context) &&
      this.dataContainer.get('Procedure', 'CanEdit') !== false
    );
  }

  delete = () => {
    swal({
      title: 'Sind Sie sich sicher?',
      text: 'Möchten Sie wirklich diese Adresse löschen?',
      icon: 'warning',
      buttons: ['Abbrechen', 'Löschen'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        reqwest({
          method: 'POST',
          url: settings.supplynetwork.clinics.remove,
          data: {
            Guid: this.props.UserGuid,
          },
        })
          .then((res) => {
            res = JSON.parse(res);

            if (res.Params.DeleteResult === 'Deleted') {
              swal({
                title: 'Erfolg!',
                text: 'Die Adresse wurde gelöscht.',
                icon: 'success',
              });
              this.props.history.replace(this.parentRoute);
            }
          })
          .catch((error) => {
            reportClinicRequestError(
              error,
              'Löschen fehlgeschlagen!',
              DELETE_ERROR_TEXT,
            );
          });
      }
    });
  };

  save = async () => {
    const isValid = await this.form.validate();
    if (!isValid) {
      swal({
        title: 'Fehler bei Ihren Eingaben',
        icon: 'error',
        text: 'Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.',
      });
      return;
    }

    const data = this.form.dataContainer.getStringified();

    reqwest({
      method: 'POST',
      url: settings.supplynetwork.clinics.save,
      data: {
        Token: localStorage.getItem('token'),
        ClinicsAdress: data,
      },
    })
      .then(() => {
        swal({
          title: 'Gespeichert!',
          text: 'Die Adresse wurde erfolgreich gespeichert.',
          icon: 'success',
        });
      })
      .catch((error) => {
        reportClinicRequestError(
          error,
          'Speichern fehlgeschlagen!',
          SAVE_ERROR_TEXT,
        );
      });
  };

  unlock = () => {
    const tempDatacontainer = new DataContainer();
    tempDatacontainer.add('UnlockedContainer', {
      Guid: this.dataContainer.get('Basic', 'Guid'),
      Unlocked: true,
    });

    reqwest({
      method: 'POST',
      url: settings.supplynetwork.clinics.save,
      data: {
        Token: localStorage.getItem('token'),
        ClinicsAdress: tempDatacontainer.getStringified(),
      },
    })
      .then(() => {
        swal({
          title: 'Adresse freigeschaltet!',
          text: 'Die Adresse wurde erfolgreich freigeschaltet.',
          icon: 'success',
        });
      })
      .catch((error) => {
        reportClinicRequestError(
          error,
          'Freischalten fehlgeschlagen!',
          SAVE_ERROR_TEXT,
        );
      });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    const canEdit = this.canEdit();

    return (
      <>
        <div className="Headerbar sticky">
          <div className="Headerbar-breadcrumbs">
            Versorgungsnetzwerk -{' '}
            <Link to="/supplynetwork/Clinics">Klinken</Link> - <b>Bearbeiten</b>
          </div>
          <div className="Headerbar-buttons">
            {canEdit && !this.dataContainer.get('Workdata', 'Unlocked') && (
              <HeaderbarButton icon={faLockOpen} onClick={this.unlock}>
                Adresse freischalten
              </HeaderbarButton>
            )}
            {canEdit && (
              <Button
                className="trash"
                type="danger"
                icon={faTrashAlt}
                onClick={this.delete}
              />
            )}
          </div>
        </div>
        <div className="Page-Content">
          <div className="Buttonbar">
            {canEdit && (
              <Button type="primary" icon={faSave} onClick={this.save}>
                Speichern
              </Button>
            )}
          </div>
          <ClinicForm
            ref={(node) => {
              this.form = node;
            }}
            dataContainer={this.dataContainer}
            isDisabled={!canEdit}
            zipValidator={REQUIRED}
          />
        </div>
      </>
    );
  }
}

export default SupplynetworkClinicsDetail;
